import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { useCreateExperiment } from 'iron/apps/experiments/src/components/hooks/create-experiment';
import styles from './index.module.styl';
export function ExperimentListPageHeader() {
  const i18n = useTranslation();
  const createExperiment = useCreateExperiment();
  const handleCreateExperiment = React.useCallback(() => {
    createExperiment();
  }, [createExperiment]);
  return <div className={styles.container} data-sentry-component="ExperimentListPageHeader" data-sentry-source-file="index.tsx">
      <div className={styles.title}>{i18n.t("experiments.list.title")}</div>
      <ButtonReact icon={"plus"} theme={ButtonTheme.Primary} onClick={handleCreateExperiment} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
        {i18n.t("experiments.list.new")}
      </ButtonReact>
    </div>;
}